import { Icon } from '@chakra-ui/react';
import { FaMarkdown } from 'react-icons/fa';

const MarkdownIcon = (props) => {
  return (
    <Icon as={FaMarkdown} {...props} />
  );
}

export default MarkdownIcon;